import { Navigate } from "react-router-dom";

function App() {
  return <Navigate to="/login" />;
}

export default App;
